import { Route, Routes } from "react-router-dom";
import DealsAndOffer from "../Components/DealsAndOffers/DealsAndOffer";

const DealsAndOfferRoutes = () => {
  return (
    <Routes>
      <Route path="/dealsAndOffers" element={<DealsAndOffer/>}></Route>
    </Routes>
  );
};

export default DealsAndOfferRoutes;
